const rainGutterSettings = {
    extraLengthMm: 20,
    distanceFromWallMm: 70
}

export default rainGutterSettings
